import { Outlet, Route } from "react-router-dom";
import { DigiSignSingle } from "../Pages/DigitalSign";

const HomeRoutes = () => {
  return <Route path="/open/*" element={<div> <Outlet /></div>}>  
    <Route index path="digital-sign"  element={<DigiSignSingle />} />
  </Route>
}


export default HomeRoutes;